import axios from 'axios';

const BASE_URL = '/api/billing-reconciliation';
const encoded = (value) => encodeURIComponent(String(value));

export const refreshBillingReconciliationVarianceClassifications = async ({
  runId,
  dryRun = true,
  includeReviewed = false,
} = {}) => {
  if (!runId) throw new Error('runId is required');
  const { data } = await axios.post(`${BASE_URL}/runs/${encoded(runId)}/variance-classifications/refresh`, {
    dryRun,
    includeReviewed,
  });
  return data;
};
